import { FunctionTrackerInfo } from 'app/app.types';
import DateRangeBookingsService from "app/services/dateRangeBookings/dateRangeBookings.service";
import ConvertJsonToCsv from "app/services/jsonToCsv/jsonToCsv.service";
import AdminService from "external-services/diary-admin-service/admin.service";
import CustomerService from "app/services/customer/customer.service";
import ReportingService from "app/services/reporting/reporting.service";
import {BookingStatusTypes} from "app/bookingStatusTypes";
import SectionLookupService from "external-services/section-lookup-service/sectionLookup.service";
import BookingLookupService from "external-services/booking-lookup-service/index";
import BookingValidationService from "shared-services/booking-validation-service/index";
import CustomerLookupService from 'external-services/customer-lookup-service';
import { LocaleService } from 'internal-services/locale/locale.service';

export default function ExportRunsheetDialogCtrl(
  $scope, $filter, bookings, date, generatedDate, services, selectedSectionIds,
  scheduleService, appConstants
) {
  "ngInject";

  var vm = this;
  vm.bookings = bookings;
  vm.date = date;
  vm.generatedDate = generatedDate;
  vm.services = services;
  vm.selectedSectionIds = selectedSectionIds;
  vm.customerBookings = [];
  vm.venue = AdminService.getVenue();

  // methods
  vm.exportToCSV = exportToCSV;

  // variables
  vm.dateRangeExport = false;
  vm.toDate = new Date();
  vm.fromDate = new Date();
  vm.errorMessage = 'Invalid Date Range';

  // online status
  vm.isOnlineCustomersEnabled = AdminService.getVenue().isOnlineCustomersEnabled;

  // states
  vm.LOADING = 1;
  vm.ENTER = 0;
  vm.INVALID = 2;
  vm.ERROR = 3;
  vm.state = vm.LOADING;

  var listeners = [];
  listeners.push($scope.$watch('vm.toDate', dateRangeChange));
  listeners.push($scope.$watch('vm.fromDate', dateRangeChange));
  listeners.push($scope.$watch('vm.dateRangeExport', dateRangeChange));

  // init
  getSectionsLookUp();

  function getSectionsLookUp() {
    vm.state = vm.LOADING;
    SectionLookupService.getSectionsLookUp().then(function (sections) {
      vm.sectionsLookup = sections;
      vm.state = vm.ENTER;
    }).catch(function (err) {
      console.error('error getSectionsLookUp', err);
    });
  }

  function dateRangeChange() {
    vm.state = vm.INVALID;
    vm.errorMessage = 'Invalid Date Range';

    if (vm.dateRangeExport) {
      if (vm.toDate && vm.fromDate) {
        vm.toDate.setHours(0, 0, 0, 0);
        vm.fromDate.setHours(0, 0, 0, 0);

        if (vm.toDate.getTime() >= vm.fromDate.getTime()) {
          vm.state = vm.ENTER;
        }

        if (((vm.toDate - vm.fromDate) / 1000 / 60 / 60 / 24) > 31) {
          vm.state = vm.INVALID;
          vm.errorMessage = 'Exceded maximum of 31 days';
        }
      }
    } else {
      vm.state = vm.ENTER;
    }
  }

  function exportToCSV() {
    vm.state = vm.LOADING;
    const currentVenue = AdminService.getVenue();
    let labels = [
      'Date', 'Service or Event', 'Time', 'Number of People', 'Booked At', 'Customer', 'Company', 'Table(s)',
      'Section', 'Status', 'Phone', 'Email', 'Booked By', 'Booked By Phone', 'Booked By Email', 'Booked By Company', 'Tags', 'Booking Options', 'Payment Amount', 'Payment Type', 'Transaction Id',
      'Booking reference', 'Staff Name', 'Booking Method', 'Multiple Venues',
      'Notes', 'Customer Notes', 'Links', 'Visits', 'AVG Spend', 'Membership Number'
    ];

    if (currentVenue.isTakeAwayMode === true) {
      labels.push('Delivery Address');
    }


    var dateString = vm.dateRangeExport ? LocaleService.formatDate(vm.fromDate, 'medium') + ' - ' + LocaleService.formatDate(vm.toDate, 'medium') : LocaleService.formatDate(vm.date, 'medium');

    var fileName = 'RunSheet ' + dateString +
      ' (generated ' + $filter('date')(vm.generatedDate, 'h:mm a') + ' ' + LocaleService.formatDateForFilename(vm.generatedDate, 'short-2y') + ')';

    let bookingsPromise;
    if (vm.dateRangeExport) {
      bookingsPromise = DateRangeBookingsService.getBookingsFromDateRange(vm.fromDate, vm.toDate);
    }
    else {
      bookingsPromise = Promise.resolve(vm.bookings);
    }

    scheduleService.getSchedulesDateLookUp(vm.fromDate, vm.toDate).then(function (schedulesLookup) {

      bookingsPromise
      .then(async (bookings) => {
        const customerIds = bookings.filter(f => f.customerId && f.status?.statusType !== BookingStatusTypes.Cancelled)
          .map(m => m.customerId);

          const customerBookingList = await BookingLookupService.getBookingsByCustomerIds(customerIds, true);
          vm.customerBookings = customerBookingList.filter(booking => BookingValidationService.isValidPastBooking(booking));
          return bookings;
      })
      .then((bookingsResult) => {
        let bookings = bookingsResult;
        let customerIds = new Set();

        // get unique customer ids from all bookings
        for (let booking of bookings) {
          if (booking.customerId && booking.status && booking.status.statusType !== 'cancelled') {
            customerIds.add(booking.customerId);
          }
        }
        customerIds = Array.from(customerIds);

        CustomerLookupService.getByIds(customerIds).then(function (customers) {
          var runSheetExport = [];
          var sectionsLookup = vm.sectionsLookup;

          if (vm.dateRangeExport) {
            bookings = filterBookings(bookings, vm.services, vm.selectedSectionIds);
          }

          ReportingService.getCustomersSpendInfo(AdminService.getVenue().id, customers.map(c => c._id))
            .then((customersAmountSpends) => {

              for (var i in bookings) {
                var booking = bookings[i];

                if (booking.status && booking.status.statusType !== 'cancelled') {
                  // Allocate Section
                  var section = '';

                  if (booking.tables && booking.tables.length === 1) {
                    let sectionId = getSectionIdFromTable(booking.tables[0])
                    section = (sectionId ? sectionsLookup[sectionId].name : "Unknown");
                  } else if (booking.tables && booking.tables.length > 1) {
                    for (var t = 0; t < booking.tables.length; t++) {
                      section = section + ',' + sectionsLookup[booking.tables[t].sectionId].name;
                    }
                    section = section.replace(',', '');
                  }

                  var selectedOptions = '';
                  if (booking.selectedOptions) {
                    for (let i = 0; i < booking.selectedOptions.length; i++) {
                      if (booking.selectedOptions[i].quantity > 0) {
                        selectedOptions += `${booking.selectedOptions[i].name} ${LocaleService.formatCurrency(booking.selectedOptions[i].price, currentVenue.currency)} x ${booking.selectedOptions[i].quantity}`;
                        if (booking.selectedOptions[i].extras && booking.selectedOptions[i].extras.length > 0) {
                          selectedOptions += ' (';
                          for (let j = 0; j < booking.selectedOptions[i].extras.length; j++) {
                            selectedOptions += booking.selectedOptions[i].extras[j].name;
                            if (j < booking.selectedOptions[i].extras.length - 1) {
                              selectedOptions += ', ';
                            }
                          }
                          selectedOptions += '), ';
                        } else if (i < booking.selectedOptions.length - 1) {
                          selectedOptions += ', ';
                        }
                      }
                    }
                  }

                  var bookingLinks = '';
                  if (booking.bookingLinks) {
                    for (let i = 0; i < booking.bookingLinks.length; i++) {
                      if (booking.bookingLinks[i].linkName && booking.bookingLinks[i].linkURL) {
                        bookingLinks += `${booking.bookingLinks[i].linkName}: ${booking.bookingLinks[i].linkURL}, `;
                      }
                    }
                  }

                  // get service names
                  var serviceName = booking.functionTracker ? FunctionTrackerInfo.name :  booking.serviceName;
                  if (!serviceName && booking.serviceId) {
                    var schedule = schedulesLookup[$filter('date')(booking.time, 'yyyy-MM-dd')];
                    if (schedule && schedule.services) {
                      for (let service of schedule.services) {
                        if (service._id === booking.serviceId) {
                          serviceName = service.name;
                        }
                      }
                    }
                    if (!serviceName) {
                      serviceName = '';
                    }
                  }

                  // get customer notes & membership number
                  var customerNotes = '';
                  var membershipNumber = '';
                  for (let customer of customers) {
                    if (customer._id === booking.customerId) {
                      customerNotes = customer.notes;
                      membershipNumber = customer.membershipNumber || membershipNumber;
                    }
                  }

                  // need to prepare it here so i can inject it as one line.
                  var delAddName = "";
                  var delAddValue = "";

                  if (AdminService.getVenue().isTakeAwayMode === true) {

                    if (booking.deliveryAddress == null) {

                      delAddName = "delivery address";
                      delAddValue = "";
                    }
                    else {

                      delAddName = "delivery address";
                      delAddValue = booking.deliveryAddress.addressLine1 + ", " + booking.deliveryAddress.addressLine2 + ", " + booking.deliveryAddress.suburb + ", " + booking.deliveryAddress.postcode + ", " + booking.deliveryAddress.state;
                    }
                  }

                  const customerAvgSpend = customersAmountSpends
                    ?.find(f => f.customerId === booking.customerId)
                      ?.averageSpend ?? 0;

                  const customerVisitsCount = vm.customerBookings?.filter(f => f.customerId === booking.customerId).length;
                  const customerForThisBooking = customers.find((v) => v._id === booking.customerId)
                  const csvData = {
                    'date': LocaleService.formatDate(booking.time, 'short'),
                    'service': serviceName,
                    'time': $filter('date')(booking.time, 'h:mm a'),
                    'people': booking.people,
                    'bookedAt': LocaleService.formatDate(booking.bookedAt, 'short') + ' ' + $filter('date')(booking.bookedAt, 'h:mm a'),
                    'fullname': (booking.firstName ? booking.firstName + ' ' : '') + (booking.lastName ? booking.lastName : ''),
                    'company': booking.company ? booking.company : '',
                    'table(s)': (booking.tables && booking.tables.length) ? arrayToString(booking.tables) : '',
                    'section': section,
                    'status': booking.status.name,
                    'phone': (booking.phone && (customerForThisBooking ? customerForThisBooking.subscribed : booking.subscribed)) ? "=\"\"" + booking.phone + "\"\"" : '',
                    'email': (booking.email && (customerForThisBooking ? customerForThisBooking.subscribed : booking.subscribed)) ? booking.email : '',
                    'bookedBy' : (booking.bookedBy?.firstName? booking.bookedBy?.firstName + ' ' : '') + (booking.bookedBy?.lastName || ''),
                    'bookedByPhone' : booking.bookedBy?.phone || '',
                    'bookedByEmail' : booking.bookedBy?.email || '',
                    'bookedByCompany' : booking.bookedBy?.company || '',
                    'tags': (booking.tags && booking.tags.length) ? arrayToString(booking.tags) : '',
                    'bookingOptions': selectedOptions,
                    'paymentAmount': (booking.paymentSummary && booking.paymentSummary.amount !== 0) ? (booking.paymentSummary.amountPaid) : '',
                    'paymentType': (booking.paymentSummary && booking.paymentSummary.paymentType !== appConstants.Payment.PaymentTypes.NoPayment) ? booking.paymentSummary.paymentType : '',
                    'transactionId': (booking.paymentSummary && booking.paymentSummary.transactionId) ? booking.paymentSummary.transactionId : '',
                    'bookingRef': booking.bookingRef,
                    'staffName': booking.staffName ? booking.staffName : '',
                    'bookingMethod': booking.method ? booking.method : '',
                    'hasVisitedMultipleVenues': booking.hasVisitedMultipleVenues ? booking.hasVisitedMultipleVenues : '',
                    'notes': (booking.notes) ? booking.notes : '',
                    'customerNotes': customerNotes ? customerNotes : '',
                    'links': bookingLinks ? bookingLinks : '',
                    'visits': customerVisitsCount ? customerVisitsCount : '',
                    'avgSpend': (customerAvgSpend / 100).toFixed(2),
                    'membershipNumber': membershipNumber,
                    delAddName: delAddValue,
                  };
                  if (!booking.bookedBy?.subscribed) {
                    csvData.bookedByPhone = '';
                    csvData.bookedByEmail = '';
                  }
                  runSheetExport.push(csvData);
                }
              }

              ConvertJsonToCsv.downloadCsv(runSheetExport, labels, fileName);
          });
        });
      });
    }).catch(function (err) {
      console.error('Error exporting runsheet', err);
      vm.state = vm.ERROR;
    }).finally(function () {
      vm.state = vm.ENTER;
    });
  }

  function getSectionIdFromTable(table) {
    if (table.sectionId)
      return table.sectionId;
    else if (table.tablesList && table.tablesList.length && table.tablesList[0].sectionId)
      return table.tablesList[0].sectionId;
    else
      return null;
  }

  function arrayToString(array) {
    var arrayMap = array.map(function (array) {
      return array.name;
    });
    return arrayMap.join();
  }

  function filterBookings(bookings, currentServices, selectedSectionIds) {

    let returnValue = [];

    // if services exist get their bookings
    if (currentServices && currentServices.length) {
      currentServices.forEach(currentService => {
        // get the bookings filtered by service if set
        var serviceId = 0;
        if (currentService) {
          serviceId = currentService._id;
        }

        // filter by serviceId
        if (serviceId) {
          returnValue = returnValue.concat(
            bookings.filter(booking => booking.serviceId === serviceId)
          );
        }
      });
    } else {
      // otherwise use same value passed in
      returnValue = bookings;
    }

    // filter bookings by selectedSectionIds
    if (selectedSectionIds && selectedSectionIds.length) {
      returnValue = returnValue.concat(
        bookings.filter(booking => !booking.tables || (booking.tables.length && booking.tables[0].sectionId && selectedSectionIds.indexOf(booking.tables[0].sectionId) !== -1))
      );
    }

    return returnValue;
  }
}
